package app

import kotlinx.serialization.Serializable

/**
 * A registered movie.
 *
 * @param lastWatchedDay epoch day (days since 1970-01-01) of the last watch,
 *   or null if it was never watched. Never-watched movies rank strongest.
 * @param posterPath TMDb poster path (e.g. "/abc.jpg"), or null if unknown.
 * @param year release year from TMDb, or null if unknown.
 */
@Serializable
data class Movie(
    val id: String,
    val title: String,
    val lastWatchedDay: Long? = null,
    val posterPath: String? = null,
    val year: Int? = null,
)
